import React, { useState, useEffect } from 'react';
import {
    X,
    Save,
    ChevronUp,
    ChevronDown,
    GripVertical,
    LayoutList
} from 'lucide-react';
import './NavReorderModal.css';

const NavReorderModal = ({ isOpen, onClose, items, onSave }) => {
    const [orderedItems, setOrderedItems] = useState([]);
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);

    useEffect(() => {
        if (items) {
            setOrderedItems([...items]);
        }
    }, [items]);

    if (!isOpen) return null;

    const moveItem = (index, direction) => {
        const newItems = [...orderedItems];
        if (direction === 'up' && index > 0) {
            [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]];
        } else if (direction === 'down' && index < newItems.length - 1) {
            [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
        }
        setOrderedItems(newItems);
    };

    const handleDragStart = (e, index) => {
        setDraggedItemIndex(index);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";

        if (draggedItemIndex === null || draggedItemIndex === index) return;

        const newItems = [...orderedItems];
        const draggedItem = newItems[draggedItemIndex];
        newItems.splice(draggedItemIndex, 1);
        newItems.splice(index, 0, draggedItem);

        setOrderedItems(newItems);
        setDraggedItemIndex(index);
    };

    const handleDragEnd = () => {
        setDraggedItemIndex(null);
    };

    const handleSave = () => {
        onSave(orderedItems);
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="nav-reorder-modal-overlay" onMouseDown={handleOverlayClick}>
            <div className="nav-reorder-modal-content animate-modal" onClick={(e) => e.stopPropagation()}>
                <header className="nav-reorder-modal-header">
                    <div className="header-title">
                        <h2>Organizar Menu</h2>
                    </div>
                    <button className="nav-reorder-close-btn" onClick={onClose} aria-label="Fechar">
                        <X size={20} />
                    </button>
                </header>

                <div className="nav-reorder-list-container">
                    <ul className="nav-reorder-list">
                        {orderedItems.map((item, index) => (
                            <li
                                key={item.id}
                                className={`nav-reorder-item ${draggedItemIndex === index ? 'dragging' : ''}`}
                                draggable
                                onDragStart={(e) => handleDragStart(e, index)}
                                onDragOver={(e) => handleDragOver(e, index)}
                                onDragEnd={handleDragEnd}
                            >
                                <div className="item-main-content">
                                    <GripVertical className="drag-handle" size={18} />
                                    <div className="item-label-group">
                                        <span className="item-icon">{item.icon}</span>
                                        <span className="item-label">{item.label}</span>
                                    </div>
                                </div>

                                <div className="nav-reorder-controls">
                                    <button
                                        className="reorder-arrow-btn"
                                        onClick={() => moveItem(index, 'up')}
                                        disabled={index === 0}
                                        title="Mover para cima"
                                    >
                                        <ChevronUp size={16} />
                                    </button>
                                    <button
                                        className="reorder-arrow-btn"
                                        onClick={() => moveItem(index, 'down')}
                                        disabled={index === orderedItems.length - 1}
                                        title="Mover para baixo"
                                    >
                                        <ChevronDown size={16} />
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <footer className="nav-reorder-actions">
                    <button className="nav-reorder-btn-cancel" onClick={onClose}>
                        Cancelar
                    </button>
                    <button className="nav-reorder-btn-save" onClick={handleSave}>
                        <Save size={18} />
                        <span>Guardar Alterações</span>
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default NavReorderModal;
